<template>
    <div class="Report__field__content">
        <div
            v-if="submission"
            class="Report__group-field-wrapper"
        >
            <div
                class="Report__field__submission"
                v-if="submission.sunday"
            >
                <v-text-field
                    type="text"
                    readonly
                    label="Sunday"
                    v-model="submission.sunday"
                    dense
                    outlined
                />
                <CopyFieldValue :value="submission.sunday" />
            </div>

            <div
                class="Report__field__submission"
                v-if="submission.monday"
            >
                <v-text-field
                    type="text"
                    readonly
                    label="Monday"
                    v-model="submission.monday"
                    dense
                    outlined
                />
                <CopyFieldValue :value="submission.monday" />
            </div>

            <div
                class="Report__field__submission"
                v-if="submission.tuesday"
            >
                <v-text-field
                    type="text"
                    readonly
                    label="Tuesday"
                    v-model="submission.tuesday"
                    dense
                    outlined
                />
                <CopyFieldValue :value="submission.tuesday" />
            </div>

            <div
                class="Report__field__submission"
                v-if="submission.wednesday"
            >
                <v-text-field
                    type="text"
                    readonly
                    label="Wednesday"
                    v-model="submission.wednesday"
                    dense
                    outlined
                />
                <CopyFieldValue :value="submission.wednesday" />
            </div>

            <div
                class="Report__field__submission"
                v-if="submission.thursday"
            >
                <v-text-field
                    type="text"
                    readonly
                    label="Thursday"
                    v-model="submission.thursday"
                    dense
                    outlined
                />
                <CopyFieldValue :value="submission.thursday" />
            </div>

            <div
                class="Report__field__submission"
                v-if="submission.friday"
            >
                <v-text-field
                    type="text"
                    readonly
                    label="Friday"
                    v-model="submission.friday"
                    dense
                    outlined
                />
                <CopyFieldValue :value="submission.friday" />
            </div>

            <div
                class="Report__field__submission"
                v-if="submission.saturday"
            >
                <v-text-field
                    type="text"
                    readonly
                    label="Saturday"
                    v-model="submission.saturday"
                    dense
                    outlined
                />

                <CopyFieldValue :value="submission.saturday" />
            </div>
        </div>
    </div>
</template>

<script>
import ReportFieldBoilerplate from '@/reports/Fields/Common/ReportFieldBoilerplate';
import CopyFieldValue from '@/reports/Fields/Common/CopyFieldValue';

export default {
    components: { CopyFieldValue },
    mixins: [
        ReportFieldBoilerplate,
    ]
};
</script>
